export function dismissKeyboard() {
  const activeElement = document.activeElement;
  if (activeElement && 'blur' in activeElement && typeof activeElement.blur === 'function') {
    activeElement.blur();
  }
}
